import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BaseComponent } from 'src/app/_base/base.component';

import { Tabnavbar } from '../models/tab-nav-bar.interface';

@Component({
  selector: 'app-tab-nav-bar',
  templateUrl: './tab-nav-bar.component.html',
  styleUrls: ['./tab-nav-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabnavbarComponent extends BaseComponent implements OnInit {
  @Input('routeLinks')
  routeLinks: Tabnavbar[];
  @Input()
  position: String = null; // left , center , left-right , space-around , null
  @Input()
  headerLabel: String = null;
  @Input()
  isTop: Boolean = false;
  @Input('activeLinkIndex')
  activeLinkIndex: Number = 0;
  public configurations: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    super();
  }
  ngOnInit() {
    this.findRouteLastSegmentName();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // on start navigate
      }

      if (event instanceof NavigationEnd) {
        this.findRouteLastSegmentName();
      }

      if (event instanceof NavigationError) {
      }
    });

    this.configurations = {
      suppressScrollX: false,
      suppressScrollY: true
    };
  }
  findRouteLastSegmentName(): void {
    let urlSegments = null;
    if (this.activatedRoute.parent.snapshot['_urlSegment'].segments.length > 0) {
      urlSegments = this.activatedRoute.parent.snapshot['_urlSegment'].segments[
        this.activatedRoute.parent.snapshot['_urlSegment'].segments.length - 1
      ].path;
      if (this.routeLinks.find(tab => tab.link === './' + urlSegments))
        this.activeLinkIndex = this.routeLinks.find(tab => tab.link === './' + urlSegments).index;
      else {
        this.activeLinkIndex = 0;
        console.log('Warning Current Last Child Of Url Does Not Exist On routeLinks List');
      }
    } else {
      this.activeLinkIndex = 0;
      console.log('Warning Current Url Does Not Exist On Segments To Read Its Index');
    }
  }
}
